module.exports = __webpack_public_path__ + "img/logo_text.e0fc3089.png";